import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { FAILURE, REQUEST, SUCCESS } from 'Stores'
import { getPlan, upgradeToEnterprise, upgradeToBasic, upgradeToTeamPlan } from 'APIs/changePlan'
import { setLocalStorage, STORAGE } from 'Utils'
import { push } from 'connected-react-router'
import { PLAN_TYPE } from 'Constants/permission'
import {
  CHANGE_TO_BASIC,
  CHANGE_TO_REGISTER_PLAN,
  CHANGE_TO_TEAM_PLAN,
  GET_PLAN
} from './constants'

export function* getPlanSaga() {
  try {
    const data = yield call(getPlan)
    yield put({
      type: SUCCESS(GET_PLAN),
      payload: {
        plan: data.result.type
      }
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_PLAN)
    })
  }
}

export function* changeToTeamPlanSaga({ payload }) {
  try {
    yield put(showOverlay())
    yield call(upgradeToTeamPlan, payload)
    setLocalStorage(STORAGE.PLAN, PLAN_TYPE.TEAM)
    yield put(push('/change-plan'))
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Change success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* changeToBasic() {
  try {
    yield put(showOverlay())
    yield call(upgradeToBasic)
    setLocalStorage(STORAGE.PLAN, PLAN_TYPE.BASIC)
    yield put(push('/change-plan'))
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Change success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* changeToRegisterSaga({ payload }) {
  try {
    yield put(showOverlay())
    yield call(upgradeToEnterprise, payload)
    setLocalStorage(STORAGE.PLAN, PLAN_TYPE.ENTERPRISE)
    yield put(push('/change-plan'))
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Change success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export default function* authSaga() {
  yield takeLatest(REQUEST(GET_PLAN), getPlanSaga)
  yield takeLatest(REQUEST(CHANGE_TO_TEAM_PLAN), changeToTeamPlanSaga)
  yield takeLatest(REQUEST(CHANGE_TO_REGISTER_PLAN), changeToRegisterSaga)
  yield takeLatest(REQUEST(CHANGE_TO_BASIC), changeToBasic)
}
